'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import MonoLabel from './MonoLabel'
import MobileMenu from './MobileMenu'
import { headerNav } from '@/lib/navigation'
import { revision, siteConfig } from '@/lib/site-config'

/**
 * Sheet header. Three ruled columns from 768px up; on mobile it collapses to
 * a sheet number, the menu trigger and a thin info bar beneath.
 */
export default function SheetHeader() {
  const pathname = usePathname()
  const stamp = `${revision()} — ${siteConfig.location}`

  return (
    <header className="border-b-frame border-ink">
      {/* Mobile: single row plus info bar */}
      <div className="md:hidden">
        <div className="flex items-stretch justify-between">
          <Link href="/" className="flex items-center px-4 py-3">
            <MonoLabel>{siteConfig.sheetNumber}</MonoLabel>
          </Link>
          <MobileMenu />
        </div>
        <div className="flex items-center justify-between border-t border-rule px-4 py-[10px]">
          <MonoLabel small className="text-ink-3">
            {siteConfig.name}
          </MonoLabel>
          <MonoLabel small className="text-ink-3">
            {`${revision()} — ${siteConfig.shortLocation}`}
          </MonoLabel>
        </div>
      </div>

      {/* Tablet and desktop: 1fr / 2fr / 1fr, ruled between */}
      <div className="hidden md:grid md:grid-cols-[1fr_2fr_1fr] md:items-center">
        <Link href="/" className="border-r border-ink px-5 py-4">
          <MonoLabel>{siteConfig.name}</MonoLabel>
        </Link>

        <nav
          aria-label="Main navigation"
          className="flex justify-center gap-4 border-r border-ink px-5 py-4 lg:gap-6"
        >
          {headerNav.map((link) => {
            const current = pathname === link.href
            return (
              <Link
                key={link.href}
                href={link.href}
                aria-current={current ? 'page' : undefined}
                className={current ? 'text-accent' : undefined}
              >
                <MonoLabel>{link.name}</MonoLabel>
              </Link>
            )
          })}
        </nav>

        <div className="px-5 py-4 text-right">
          <MonoLabel className="text-ink-3">{stamp}</MonoLabel>
        </div>
      </div>
    </header>
  )
}
